import { FastifyReply } from 'fastify';
import { InjectionToken } from '@angular/core';

export interface Cookies {
  [key: string]: string;
}

export const COOKIES = new InjectionToken<string>('COOKIES');
export const REPLY = new InjectionToken<FastifyReply>('REPLY');
export const RESPONSE = new InjectionToken<ResponseInit>('RESPONSE');
